<template>
  <div class="schoolProfile">
    <div class="begin everyParagraph">
      各位同学大家好！欢迎大家进入中央广播电视中等专业学校学习，通过本书可以了解中央广播电视中等专业学校的历史，了解相关专业及学制，明确从报名注册到毕业的相关流程，熟悉学习及考试方式，从而帮助大家更好的完成专业学习，获得相应学分，最终顺利毕业！
    </div>
    <div class="everyParagraph">
      <div class="paragraphTitle">一、学校介绍</div>
      <div class="paragraphContent">
        <p>中央广播电视中等专业学校是一所经原国家教委批准、现由教育部职业教育与成人教育司领导并依托国家开放大学（原中央广播电视大学）设置的运用现代化教学手段和多媒体教学开展中等专业学历教育的开放性学校，其主要职责是负责全国电大系统中等职业教育的教学和教学管理方面的统筹协调、指导服务和评估监督，并面向社会直接招收初高中毕业生和在职青年举办中等职业教育。学校具有颁发国民教育系列中等学历教育毕业证书的资格。</p>
        <div class="oneImg">
          <img src="../../assets/img/pcIndex.png" width="100%"/>
          <p>图1-1 中央广播电视中等专业学校网站（http://zzx.ouchn.edu.cn）</p>
        </div>

        <p>中央广播电视中等专业学校是一所经原国家教委批准、现由教育部职业教育与成人教育司领导并依托国家开放大学（原中央广播电视大学）设置的运用现代化教学手段和多媒体教学开展中等专业学历教育的开放性学校，其主要职责是负责全国电大系统中等职业教育的教学和教学管理方面的统筹协调、指导服务和评估监督，并面向社会直接招收初高中毕业生和在职青年举办中等职业教育。学校具有颁发国民教育系列中等学历教育毕业证书的资格。</p>
        <p>中央广播电视中等专业学校始终坚持面向地方、面向农村、面向基层、面向边远和民族地区办学，坚持“以服务为宗旨、以就业为导向”的职业教育办学理念，紧密结合社会经济建设发展对应用性人才的需求，为成人中等文化教育、实用技术培训、资格证书教育和岗位培训提供教学服务。同时，中央广播电视中等专业学校积极探索远程职业教育领域校企合作、工学结合形式下的教学模式、管理模式和运行机制，相继开展了“校企助读试点”“校企合作分段式培养试点”及“半工半读试点”等项目，被教育部确定为全国先期开展半工半读试点工作的职业院校之一。</p>
        <div class="towImg">
          <div class="jiaoyu">
            <img src="../../assets/img/jiaoyu1.png" width="50%"/>
            <img src="../../assets/img/jiaoyu2.png" width="50%"/>
          </div>
          
          <p>图1-2 政策文件</p>
        </div>
      </div>
    </div>
    <div class="everyParagraph">
      <div class="paragraphTitle">二、专业及学制</div>
      <div class="paragraphContent">
        <p>1. 开设的专业</p>
        <p>
          专业大类：农林牧渔、资源环境与安全、土木建筑、装备制造、生物与化工、食品药品与粮食、交通运输、电子与信息、医药卫生、财经商贸、旅游、文化艺术、新闻传播、公共管理与服务。
        </p>
        <p>专业名称：建筑工程施工、机电技术应用、化学工艺、计算机应用、会计事务、电子商务等30多个。</p>
        <p>2. 学制及入学年龄</p>
        <p>（1）学制及入学年龄</p>
        <p>初中起点学生可修两年制或三年制专业，两年制学生需年满16 周岁，三年制学生需年满 15 周岁；高中起点学生可修一年制专业，需年满 18 周岁。</p>
        <p>（2）学籍有效期</p>
        <p>初中起点两年制学籍有效期6年，初中起点三年制学籍有效期8年，高中起点一年制学籍有效期3年。</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "schoolProfile",
  data() {
    return {
     
    };
  },
  props: [],

  created(){
    
  },
  methods: {},
};
</script>
<style scoped>
.schoolProfile {
  padding: 10px 20px;
  line-height: 25px;
  font-size: 14px;
}
.schoolProfile .begin {
  text-indent: 32px;
}
.everyParagraph {
  margin-bottom: 20px;
}
.schoolProfile .title {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}
.schoolProfile img {
  margin: 20px 0;
}
.towImg .jiaoyu {
  display: flex;
}
.towImg .jiaoyu img {
  flex: 1;
}
.towImg p,.oneImg p {
  font-size: 13px;
}
.towImg p {
  text-align: center;
}
</style>